// 表单通用布局

export const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

export const formStyle = {
    paddingLeft: "20px",
    paddingRight: "30px",
};

